import { Text } from "components/common";
import React, { forwardRef, useContext } from "react";
import shareBg from "assets/share-all.png";
import { css } from "@emotion/css";
import { UserContext } from "context";
import { Footer } from "./footer";
import { format } from "date-fns";
import { SharableContent } from "./sharableContent";
import { CARD_HEIGHT } from "utils/constants";
import { ShareBtn } from "./shareBtn";


const offset = 50;

function formatDurationInHoursAndMinutes(totalMinutes: number) {
  const durationDate = new Date(0);
  durationDate.setMinutes(totalMinutes);

  return format(durationDate, "H'h' m'min'");
}

type Props = {
  handleNext?: VoidFunction;
    handleShare: (option: 'twitter' | 'facebook' | 'linkedin') => void;
    index: number;
    ref: React.Ref<HTMLDivElement>;
    shareLoading?: boolean;
};
export const StatsSummary = forwardRef<HTMLDivElement, Props>(({index, handleShare, shareLoading}, ref) => {
  const {state: userState} = useContext(UserContext);
  const stats = (userState?.emailStats?.avgEmailPerDay || 0).toFixed(0);
  const [isShare, setIsShare] = React.useState(false);
    const onShare = (option: 'twitter' | 'facebook' | 'linkedin') => {
      setIsShare(true);
      setTimeout(async () => {
      await handleShare(option);
          setIsShare(false);
      }, 1000);
    };
    
  return (
    <>
    <div
      className={css`
        border: 1.825px solid #29282f;
        height: calc(100vh - ${offset}px);
        max-height: calc(${CARD_HEIGHT}px - ${offset}px);
        width: 100%;
        border-radius: 40px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        padding: 50px 24px 105px 24px;
        transition: transform 0.3s;
        background: url(${shareBg});
        background-repeat: no-repeat;
        background-position: top 0px left -100px;
        background-size: cover;
        position: relative;
        overflow: hidden;
      `}
    >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Text.Body
          style={{
            marginBottom: "40px",
            marginTop: "5px",
            fontSize: "60px",
            color: "#AAEF65",
            zIndex: 2,
          }}
        >
          {userState?.emailStats?.totalEmailReceived || 0}
        </Text.Body>
  
        <Text.Body style={{ fontSize: "30px", zIndex: 2, marginBottom: "0px", }}>
          My 2024 email count
        </Text.Body>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center'  }}>
        <Text.Body
              style={{
                marginBottom: "40px",
                marginTop: "5px",
                fontSize: "60px",
                color: "#AAEF65",
                zIndex: 2,
              }}
            >
              {stats}
            </Text.Body>
      <Text.Body
        style={{
          marginBottom: "0px",
          marginTop: "5px",
          fontSize: "30px",
          zIndex: 2,
          textAlign: "center",
        }}
      >
        My daily email average
      </Text.Body>
      </div>

      <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Text.Body
          style={{
            marginBottom: "40px",
            marginTop: "5px",
            fontSize: "60px",
            color: "#AAEF65",
            zIndex: 2,
          }}
        >
          {formatDurationInHoursAndMinutes(userState?.emailStats?.avgResponseTime || 0)}
        </Text.Body>
        <Text.Body
          style={{
            marginBottom: "0px",
            marginTop: "5px",
            fontSize: "30px",
            zIndex: 2,
            textAlign: "center",
          }}
        >
          The average time it took me to respond to an email
        </Text.Body>
      </div>

      {shareLoading ? (
              <Text.Body style={{ fontSize: "28px", zIndex: 2 }}>Sharing...</Text.Body>
            ) : <ShareBtn handleShare={onShare} />}
    </div>

    {isShare && <SharableContent>
          <div
      ref={ref}
      className={css`
        width: 560px;
        height: 700px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        padding: 50px 24px 105px 24px;
        transition: transform 0.3s;
        background: url(${shareBg});
        background-repeat: no-repeat;
        background-position: top 0px left 0px;
        background-size: 100% 100%;
        position: relative;
        overflow: hidden;
      `}
    >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Text.Body
          style={{
            marginBottom: "40px",
            marginTop: "5px",
            fontSize: "100px",
            color: "#AAEF65",
            zIndex: 2,
          }}
        >
          {userState?.emailStats?.totalEmailReceived || 0}
        </Text.Body>
  
        <Text.Body style={{ fontSize: "30px", zIndex: 2, marginBottom: "0px", }}>
          My 2024 email count
        </Text.Body>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center'  }}>
        <Text.Body
              style={{
                marginBottom: "40px",
                marginTop: "5px",
                fontSize: "100px",
                color: "#AAEF65",
                zIndex: 2,
              }}
            >
              {stats}
            </Text.Body>
      <Text.Body
        style={{
          marginBottom: "0px",
          marginTop: "5px",
          fontSize: "30px",
          zIndex: 2,
          textAlign: "center",
        }}
      >
        My daily email average
      </Text.Body>
      </div>

      <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Text.Body
          style={{
            marginBottom: "40px",
            marginTop: "5px",
            fontSize: "100px",
            color: "#AAEF65",
            zIndex: 2,
          }}
        >
          {formatDurationInHoursAndMinutes(userState?.emailStats?.avgResponseTime || 0)}
        </Text.Body>
        <Text.Body
          style={{
            marginBottom: "0px",
            marginTop: "5px",
            fontSize: "30px",
            zIndex: 2,
            textAlign: "center",
          }}
        >
          The average time it took me to respond to an email
        </Text.Body>
      </div>

      <Footer />
    </div>
    </SharableContent>}
    </>
  );
});
